<p-toast
  styleClass="admin-panel-toast"
  class="mt-3"
  position="top-center"
></p-toast>

<div
  *ngIf="isPageAllSelected || selectAllEntries"
  class="admin-select-all-banner"
>
  <span>{{
    selectAllEntries
      ? "All the entries are selected"
      : "All the entries on this page are selected"
  }}</span>
  <button
    type="button"
    class="admin-select-all-link"
    (click)="selectAllEntries ? clearTableSelection() : selectAllItems()"
  >
    {{
      selectAllEntries
        ? "Clear selection"
        : "Select all " +
          (adminTable?.filteredValue ?? tableData).length +
          " entries"
    }}
  </button>
</div>

<p-table
  #adminTable
  [value]="skeletonLoader ? skeletonData : displayData"
  responsiveLayout="scroll"
  [(selection)]="selectedItems"
  dataKey="id"
  styleClass="user-management-table"
  [paginator]="true"
  [rows]="10"
  [columns]="tableColumns"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} of {totalRecords} entries"
  [showFirstLastIcon]="false"
  [rowsPerPageOptions]="pagination.options"
  (onRowSelect)="checkRow($event)"
  (onRowUnselect)="checkRow($event)"
  (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
  (onPage)="onPageChange($event)"
  (onFilter)="onTableFilter()"
  appendTo="body"
  paginatorDropdownAppendTo="body"
  [(first)]="paginationFirst"
  [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
>
  <ng-template pTemplate="header">
    <tr>
      <!-- dynamic column names -->
      <ng-container *ngFor="let column of tableColumns">
        <th
          class="col-minwidth {{ column.value }}-th cursor-pointer"
          [pSortableColumn]="column.sortable ? column.value : ''"
          (click)="handleHeaderClick($event, column)"
          [style.width]="column.width"
        >
          <p-tableHeaderCheckbox
            *ngIf="column?.valueType === 'checkbox'"
            class="experiment-checkbox"
          ></p-tableHeaderCheckbox>

          <span
            class="flex items-center justify-start gap-2"
            [class.justify-around]="column.value === 'actions'"
            *ngIf="column?.valueType !== 'checkbox'"
          >
            <span>{{ column.label }} </span>

            <span class="custom-sort-icon" *ngIf="column.sortable">
              <img
                src="/assets/images/icon-arrow-sort-normal.svg"
                *ngIf="!isSortedColumn(column)"
              />
              <img
                src="/assets/images/icon-arrow-sort.svg"
                *ngIf="isSortedColumn(column)"
                [ngClass]="{
                  asc: isAscending(column),
                  desc: isDescending(column),
                }"
              />
            </span>
          </span>
        </th>
      </ng-container>
    </tr>
    <tr class="filters-row" *ngIf="!skeletonLoader && showFilters">
      <ng-container
        *ngFor="let column of tableColumns; let i = index; let lastIndex = last"
      >
        <th>
          <p-columnFilter
            *ngIf="column?.filterType === 'input_text'"
            matchMode="contains"
            [field]="column.value"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <input
                type="text"
                class="filter-input"
                pInputText
                [ngModel]="value"
                [ngModelOptions]="{ standalone: true }"
                (input)="filterData($event, filter, column?.filterType)"
              />
            </ng-template>
          </p-columnFilter>

          <p-columnFilter
            *ngIf="column?.filterType === 'dropdown'"
            [field]="column.value"
            matchMode="in"
            [showMenu]="false"
            [showClearButton]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <ng-select
                *ngIf="column?.filterType === 'dropdown'"
                [items]="column.filterOptions"
                [multiple]="true"
                bindLabel="label"
                bindValue="value"
                [ngModel]="value"
                placeholder="Select {{
                  column.label ? column.label : 'Option'
                }}"
                [closeOnSelect]="false"
                [searchable]="false"
                [clearable]="false"
                appendTo="body"
                (change)="filterData($event, filter, column?.filterType)"
                class="filter-dropdown"
              >
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-index="index"
                  let-item$="item$"
                >
                  <input type="checkbox" [checked]="item$.selected" readonly />
                  {{ item.label }}
                </ng-template>

                <ng-template ng-multi-label-tmp let-items="items">
                  <span class="ng-placeholder"
                    >Select {{ column.label ? column.label : "Option" }}</span
                  >
                </ng-template>
              </ng-select>
            </ng-template>
          </p-columnFilter>

          <p-columnFilter
            *ngIf="column?.filterType === 'date_range'"
            [field]="column.value"
            matchMode="between"
            [showMenu]="false"
            [showClearButton]="false"
            [class.expand_date_picker]="column?.canExpand"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <div class="eda-datepicker date-filter-item calendar-wrapper">
                <p-calendar
                  class="eda-calendar filter-date-range"
                  #edaCalendar
                  [ngModel]="value"
                  [ngModelOptions]="{ standalone: true }"
                  view="month"
                  dateFormat="M-yy"
                  [readonlyInput]="true"
                  inputId="pickmonth"
                  [showIcon]="true"
                  [hideOnDateTimeSelect]="false"
                  appendTo="body"
                  selectionMode="range"
                  placeholder="Select Date"
                  (onClickOutside)="
                    handleClickOutside(edaCalendar, column.value)
                  "
                >
                  <ng-template pTemplate="footer">
                    <div class="calendar-footer">
                      <button
                        class="btn btn-primary btn-sm apply"
                        (click)="
                          applyDateFilter(
                            edaCalendar.value,
                            filter,
                            column.value
                          );
                          edaCalendar.hideOverlay()
                        "
                        [disabled]="isDatesSelected(edaCalendar?.value)"
                      >
                        Apply
                      </button>
                      <button
                        class="btn btn-outline-secondary btn-sm reset"
                        (click)="resetCalendar(filter, column.value)"
                      >
                        Reset
                      </button>
                    </div>
                  </ng-template>
                </p-calendar>
              </div>
            </ng-template>
          </p-columnFilter>
        </th>
      </ng-container>
    </tr>
    <tr *ngIf="showFilterRow" class="admin-filter-row">
      <ng-container *ngFor="let column of tableColumns">
        <th
          *ngIf="
            column.valueType !== 'zoneUserActions' &&
              column.valueType !== 'roleActions';
            else emptyFilterTh
          "
        >
          <input
            *ngIf="column.valueType !== 'checkbox'"
            class="admin-filter-input"
            type="text"
            placeholder="Type here"
            [(ngModel)]="columnFilters[column.value]"
            (ngModelChange)="applyColumnFilters()"
          />
        </th>
        <ng-template #emptyFilterTh><th></th></ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-data>
    <ng-template [ngIf]="skeletonLoader">
      <tr>
        <td *ngFor="let column of tableColumns">
          <p-skeleton height="1rem" styleClass="mb-2"></p-skeleton>
        </td>
      </tr>
    </ng-template>
    <ng-template [ngIf]="!skeletonLoader">
      <tr>
        <!-- dynamic table data -->
        <ng-container *ngFor="let column of tableColumns">
          <td *ngIf="column?.valueType === 'checkbox'">
            <p-checkbox
              class="experiment-checkbox"
              [binary]="true"
              [inputId]="'checkbox-' + data.id"
              [ngModel]="isRowSelected(data)"
              (onChange)="toggleRowSelection($event, data)"
            ></p-checkbox>
          </td>

          <td
            class="key-accounts"
            style="color: #325a6d; width: 20rem"
            *ngIf="column.valueType === 'userKeyAccounts'"
            (click)="viewKeyAccounts(data, 'addEditKeyAccounts')"
          >
            {{ data[column.value]?.length }} Key accounts
            <i class="fa fa-eye"></i>
          </td>

          <td *ngIf="column.valueType === 'zoneKeyAccountsCount'">
            <button
              type="button"
              class="key-accounts-link"
              [attr.aria-label]="
                'View ' + (data[column.value]?.length || 0) + ' key accounts'
              "
              (click)="onTableAction(data, { action: 'addEditKeyAccounts' })"
            >
              {{ data[column.value]?.length || 0 }} Key accounts
              <i class="pi pi-eye key-accounts-eye"></i>
            </button>
          </td>
          <td
            *ngIf="
              column.value === 'requested_at' ||
              column.value === 'created_at' ||
              column.value === 'approved_at'
            "
          >
            {{ formatReadableDate(data[column.value]) }}
          </td>
          <td
            *ngIf="
              column.valueType === 'reqUserName' ||
              column.valueType === 'appUsersName'
            "
          >
            {{
              data["first_name"] || data["last_name"]
                ? data["first_name"] + " " + data["last_name"]
                : "-"
            }}
          </td>
          <td
            *ngIf="
              column.valueType === 'reqApprovedBy' ||
              column.valueType === 'reqRejectedBy'
            "
          >
            <span
              *ngIf="
                data['approved_by_first_name'] || data['approved_by_last_name']
              "
            >
              {{ data["approved_by_first_name"] || "" }}
              {{ data["approved_by_last_name"] || "" }}
            </span>
            <span
              *ngIf="
                !data['approved_by_first_name'] &&
                !data['approved_by_last_name']
              "
              >-</span
            >
          </td>

          <td *ngIf="column.valueType === 'userDetails'">
            <span
              style="
                font: normal normal 600 14px/19px Open Sans;
                color: #000000;
              "
              >{{ data["first_name"] }} {{ data["last_name"] }}</span
            >
            <p
              style="
                font: normal normal normal 12px/17px Open Sans;
                color: #7b7b7b;
                margin: 0px;
              "
            >
              {{ data["email"] }}
            </p>
          </td>
          <td
            *ngIf="column.valueType === 'linkView'"
            [class]="column?.class"
            [ngStyle]="column?.tdStyle"
          >
            <span
              class="link-view"
              (click)="onTableAction(data, { action: 'link-view' })"
              >{{ data[column.value] }}</span
            >
          </td>
          <td
            [style.width]="column.valueType === 'expName' ? '15rem' : null"
            *ngIf="
              column.valueType === 'expName' ||
              column.valueType === 'expKeyAccount'
            "
          >
            {{ data[column.value] }}
          </td>
          <td
            *ngIf="
              column.valueType === 'expZone' ||
              column.valueType === 'appKeyAccZone'
            "
          >
            {{ zoneDict[data[column.value]] }}
          </td>
          <td
            *ngIf="
              column.valueType === 'expCreatedBy' ||
              column.valueType === 'appZoneAdmin'
            "
          >
            {{ data[column.value] }}
          </td>
          <td
            *ngIf="
              column.valueType === 'reqType' ||
              column.valueType === 'userRequestsType'
            "
          >
            {{ requestTypes[data[column.value]] }}
          </td>
          <td
            *ngIf="
              column.valueType === 'expType' ||
              column.valueType === 'userRequestsStatus'
            "
          >
            {{
              column.valueType === "expType"
                ? experimentTypesMap[data[column.value]]
                : (data[column.value] | titlecase)
            }}
          </td>
          <td *ngIf="column.value === 'role'">
            {{ data[column.value] | titlecase }}
          </td>

          <td *ngIf="column.valueType === 'zoneUserRoles'" class="roles-cell">
            <div class="roles-cell__wrap">
              <ng-container *ngIf="data['roles']?.length">
                <span *ngFor="let r of data['roles']" class="role-pill">{{
                  r.title
                }}</span>
              </ng-container>
              <span
                *ngIf="!data['roles']?.length && data['role']"
                class="role-pill"
                >{{ data["role"] | titlecase }}</span
              >
              <span *ngIf="!data['roles']?.length && !data['role']">-</span>
            </div>
          </td>

          <td
            *ngIf="column.valueType === 'zoneUserActions'"
            class="zone-actions-td"
          >
            <span class="zone-actions-wrap">
              <button
                type="button"
                class="btn-icon-action"
                title="Migrate Zone"
                aria-label="Migrate Zone"
                (click)="onTableAction(data, { action: 'migrateZone' })"
              >
                <i class="pi pi-arrow-right-arrow-left"></i>
              </button>
              <button
                type="button"
                class="btn-icon-action"
                title="Revoke Zone"
                aria-label="Revoke Zone"
                (click)="onTableAction(data, { action: 'revokeZone' })"
              >
                <i class="pi pi-user-minus"></i>
              </button>
              <button
                type="button"
                class="btn-icon-action"
                title="Manage Roles"
                aria-label="Manage Roles"
                (click)="onTableAction(data, { action: 'manage_roles' })"
              >
                <i class="pi pi-user-edit"></i>
              </button>
            </span>
          </td>

          <td
            *ngIf="column.valueType === 'roleActions'"
            class="role-actions-td"
          >
            <span class="role-actions-wrap">
              <button
                type="button"
                class="btn-icon-action"
                title="View"
                aria-label="View"
                (click)="onTableAction(data, { action: 'view' })"
              >
                <i class="pi pi-eye"></i>
              </button>
              <button
                *ngIf="data.canEdit !== false"
                type="button"
                class="btn-icon-action"
                title="Edit"
                aria-label="Edit"
                (click)="onTableAction(data, { action: 'edit' })"
              >
                <i class="pi pi-pencil"></i>
              </button>
              <button
                *ngIf="data.canDelete !== false"
                type="button"
                class="btn-icon-action btn-icon-action--danger"
                [title]="
                  data.userCount > 0
                    ? 'Cannot delete — role has assigned users'
                    : 'Delete'
                "
                aria-label="Delete"
                [disabled]="data.userCount > 0"
                (click)="onTableAction(data, { action: 'delete' })"
              >
                <i class="pi pi-trash"></i>
              </button>
            </span>
          </td>

          <td *ngIf="column.value === 'is_beta_user'">
            <span *ngIf="data[column.value]">Yes</span>
            <span *ngIf="!data[column.value]">No</span>
          </td>

          <td *ngIf="column.valueType === 'reqCreatedBy'">
            {{
              data["requested_by_first_name"] || data["requested_by_last_name"]
                ? data["requested_by_first_name"] +
                  " " +
                  data["requested_by_last_name"]
                : "-"
            }}
          </td>
          <td *ngIf="column.value === 'is_active'">
            <mat-slide-toggle
              [checked]="data[column.value]"
              class="status-toggle"
              (change)="toggleUserStatus($event, data)"
            >
              <span>{{ data[column.value] ? "Active" : "Inactive" }}</span>
            </mat-slide-toggle>
          </td>
          <td *ngIf="column.valueType === 'appUserZones'">
            {{
              data[column.value]
                ? data[column.value].length > 0
                  ? data[column.value].toString()
                  : "-"
                : "-"
            }}
          </td>
          <td *ngIf="column.valueType === 'dropdown'">
            <p-dropdown
              [options]="column.dropdownOptions"
              styleClass="dropdown-view"
              [(ngModel)]="data[column.value]"
              (onChange)="onTableAction(data, data[column.value])"
            >
              <!-- Custom template for selected item -->
              <ng-template let-selectedOption pTemplate="selectedItem">
                <div class="capitalize">
                  {{ selectedOption?.split("_").join(" ") }}
                </div>
              </ng-template>
              <ng-template let-option pTemplate="item">
                <div class="capitalize">
                  {{ option?.split("_").join(" ") }}
                </div>
              </ng-template>
            </p-dropdown>
          </td>
          <td
            *ngIf="
              column.value !== 'actions' &&
              column.value !== 'requested_at' &&
              column.value !== 'created_at' &&
              column.value !== 'approved_at' &&
              column.value !== 'key_accounts' &&
              column.value !== 'key_account' &&
              column.value !== 'zone' &&
              column.valueType !== 'expName' &&
              column.valueType !== 'reqType' &&
              column.valueType !== 'expType' &&
              column.valueType !== 'reqCreatedBy' &&
              column.valueType !== 'expCreatedBy' &&
              column.valueType !== 'userRequestsStatus' &&
              column.valueType !== 'userRequestsType' &&
              column.valueType !== 'appZoneAdmin' &&
              column.valueType !== 'reqApprovedBy' &&
              column.valueType !== 'reqRejectedBy' &&
              column.valueType !== 'appKeyAccZone' &&
              column.value !== 'is_active' &&
              column.value !== 'is_beta_user' &&
              column.valueType !== 'appUserZones' &&
              column.value !== 'role' &&
              column.valueType !== 'appUsersName' &&
              column.valueType !== 'dropdown' &&
              column.valueType !== 'userDetails' &&
              column.valueType !== 'linkView' &&
              column.valueType !== 'checkbox' &&
              column.valueType !== 'zoneUserRoles' &&
              column.valueType !== 'zoneUserActions' &&
              column.valueType !== 'zoneKeyAccountsCount' &&
              column.valueType !== 'userKeyAccounts' &&
              column.valueType !== 'roleActions'
            "
            [ngStyle]="column?.tdStyle"
            [matTooltip]="column?.showTooltip ? data[column.value] : ''"
          >
            <div
              [class]="column?.class"
              [ngStyle]="{
                'background-color':
                  data[column.value] === 'high'
                    ? 'var(--pho_red_light)'
                    : data[column.value] === 'medium'
                      ? 'var(--pho_orange_light)'
                      : data[column.value] === 'low'
                        ? 'var(--pho_green_light)'
                        : 'transparent',
                color:
                  data[column.value] === 'high'
                    ? 'var(--pho_red)'
                    : data[column.value] === 'medium'
                      ? 'var(--pho_orange)'
                      : data[column.value] === 'low'
                        ? 'var(--pho_green)'
                        : 'black',
              }"
            >
              {{ data[column.value] ? data[column.value] : "-" }}
            </div>
          </td>
        </ng-container>
        <td
          class="actions-td"
          *ngIf="
            dataFrom !== 'rejectedRequests' &&
            dataFrom !== 'approvedRequests' &&
            dataFrom !== 'userProfile' &&
            dataFrom !== 'userRequests' &&
            dataFrom !== 'experiments' &&
            dataFrom !== 'tickets' &&
            dataFrom !== 'users' &&
            dataFrom !== 'roles'
          "
        >
          <!-- dynamic table actions -->
          <ng-container *ngFor="let action of tableActions">
            <button
              *ngIf="!action.from"
              class="btn {{ action.action }}_btn"
              (click)="onTableAction(data, action)"
            >
              {{ action.label }}
              <img src="/assets/images/{{ action.btnIcon }}.svg" alt="" />
            </button>
            <img
              class="reject-approve-images"
              style="margin-right: 8px; cursor: pointer"
              *ngIf="action.from"
              src="/assets/images/{{ action.btnIcon }}.svg"
              alt=""
              [title]="action.btnIcon"
              (click)="onTableAction(data, action)"
            />
          </ng-container>
        </td>

        <td
          class="actions-td"
          *ngIf="dataFrom === 'experiments' || dataFrom === 'tickets'"
        >
          <ng-container>
            <button mat-button [matMenuTriggerFor]="menu">
              <img src="/assets/images/popup-icon.svg" alt="" />
            </button>

            <mat-menu #menu="matMenu" class="custom-menu">
              <ng-container *ngFor="let action of tableActions">
                <button
                  mat-menu-item
                  *ngIf="!action.from"
                  (click)="onTableAction(data, action)"
                >
                  <div class="content-wrapper">
                    <span class="menu-label">{{ action.label }}</span>
                    <span
                      ><img
                        src="/assets/images/{{ action.btnIcon }}.svg"
                        alt=""
                      />
                    </span>
                  </div>
                </button>
                <button
                  mat-menu-item
                  *ngIf="action.from"
                  (click)="onTableAction(data, action)"
                >
                  <div class="content-wrapper">
                    <span class="menu-label">{{ action.label }}</span>
                    <span>
                      <img
                        src="/assets/images/{{ action.btnIcon }}.svg"
                        alt=""
                        [title]="action.btnIcon"
                      />
                    </span>
                  </div>
                </button>
              </ng-container>
            </mat-menu>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td
        style="text-align: center; padding: 20px 10px"
        [attr.colspan]="columns?.length"
      >
        No records found
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="paginatorleft" let-state> Showing </ng-template>
</p-table>
